import React, { MouseEvent } from 'react';
import { Dialog, Link, Typography } from '@material-ui/core';
import ClosableDialogContent from './ClosableDialogContent';
import ClosableDialogTitle from './ClosableDialogTitle';
import { getLinkTextFromDate } from './Utils';

// This resolves to nothing and doesn't affect browser history and without it will not change the mouse icon as clickable when it hover over the link.
// eslint-disable-next-line no-script-url
const dudUrl = 'javascript:;';

/*
  This component it's related to the task GSDCP-58.
  It needs a Date, Title as props and a Dialog Content as a Child.
  Ex.:
    <ClosableDialogLink lastUpdateDate={lastUpdateDate} title={title}>
      <LogTable tableColumns={tableColumns}/>
    </ClosableDialogLink>
*/
interface ClosableDialogLinkProps {
  lastUpdateDate?: Date | null;
  title: string;
}

interface ClosableDialogLinkState {
  open: boolean;
}

class ClosableDialogLink extends React.Component<ClosableDialogLinkProps, ClosableDialogLinkState> {
  constructor(props: ClosableDialogLinkProps) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClickOpen = (e: MouseEvent) => {
    this.setState({ open: true });
    e.stopPropagation();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    // TODO: Language should be in the context or I18N. Change when I18N it's DONE.
    const languageSelected = 'English';
    const { lastUpdateDate, title, children } = this.props;
    const { open } = this.state;
    const linkText = lastUpdateDate ? getLinkTextFromDate(lastUpdateDate.toString(), languageSelected) : 'Not Started';

    return (
      <div>
        <Typography>
          <Link href={dudUrl} variant="body2" color="inherit" onClick={this.handleClickOpen}>
            {linkText}
          </Link>
        </Typography>
        <Dialog
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
          }}
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
          maxWidth="xl"
        >
          <ClosableDialogTitle onClose={this.handleClose}>{title}</ClosableDialogTitle>

          <ClosableDialogContent dividers>{children}</ClosableDialogContent>
        </Dialog>
      </div>
    );
  }
}

export default ClosableDialogLink;
